<template>
  <div class="block">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="params.pn"
      :page-sizes="[20, 40, 80, 100]"
      :page-size="20"
      layout="total, sizes, prev, pager, next, jumper"
      :total="params.pc">
    </el-pagination>
  </div>
</template>

<script>
    export default {
      name:"page-box",
      data() {
        return {
          currentPage: 1
        };
      },
      props:[
        'params'//接受父组件参数
      ],
      methods: {
        handleSizeChange(val) {
          console.log(`每页 ${val} 条`);
          //向父组件传递参数
          const data=val;
          this.$emit('pageBox','ps',data);
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`);
          const data=val;
          this.$emit('pageBox','pn',data);
        }
      }
    }
</script>

<style scoped>
  .block{
    text-align: right;
    margin-top: .5%;
  }
</style>
